/**
 * Snooze API helpers for Approval Queue
 */

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
const getAdminToken = () => 'dev';

/**
 * Snooze an approval for a specified duration
 * @param {Object} params
 * @param {string} params.brandId - Brand ID
 * @param {string} params.traceId - Trace ID to snooze
 * @param {number} params.minutes - Duration in minutes (5 min to 14 days)
 * @param {string} [params.actor] - Optional actor identifier
 */
export async function snoozeApproval({ brandId, traceId, minutes, actor }) {
  const res = await fetch(
    `${API_BASE}/api/v1/integrations/slack/snooze`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Admin-Token': getAdminToken()
      },
      body: JSON.stringify({
        brand_id: brandId,
        trace_id: traceId,
        minutes: minutes,
        actor: actor || null
      })
    }
  );
  
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to snooze approval');
  }
  
  return res.json();
}

/**
 * Unsnooze an approval, making it appear in the pending list again
 */
export async function unsnoozeApproval({ brandId, traceId, actor }) {
  const res = await fetch(
    `${API_BASE}/api/v1/integrations/slack/unsnooze`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Admin-Token': getAdminToken()
      },
      body: JSON.stringify({
        brand_id: brandId,
        trace_id: traceId,
        actor: actor || null
      })
    }
  );
  
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to unsnooze approval');
  }
  
  return res.json();
}

/**
 * Fetch snoozed approvals
 */
export async function fetchSnoozedApprovals(brandId, limit = 200) {
  const res = await fetch(
    `${API_BASE}/api/v1/integrations/slack/snoozed-approvals?brand_id=${encodeURIComponent(brandId)}&limit=${limit}`,
    {
      headers: {
        'X-Admin-Token': getAdminToken()
      }
    }
  );
  
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || 'Failed to fetch snoozed approvals');
  }
  
  return res.json();
}
